<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Menu - Zápatí - Kategorie - Přidat</strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="Nadpis"
          :validate-status="nameError() ? 'error' : ''"
          :help="nameError() || ''"
        >
          <a-input @change="handleChange" placeholder="Název" v-decorator="['mfe_title', {rules: [{max: 30, message: 'Název nemůže být delší než 30 znaků'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>
        <a-form-item>
          <span slot="label">
            Blog&nbsp;
            <a-tooltip title="Pod nadpisem se zobrazí seznam blog kategorií">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-checkbox :disabled="this.form.getFieldValue('mfe_is_ecommerce_categories')" v-decorator="['mfe_is_blog', { valuePropName: 'checked', initialValue: false }]"/>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            E-shop&nbsp;
            <a-tooltip title="Pod nadpisem se zobrazí seznam e-shop kategorií">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-checkbox :disabled="this.form.getFieldValue('mfe_is_blog')" v-decorator="['mfe_is_ecommerce_categories', { valuePropName: 'checked', initialValue: false }]"/>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Přidat</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '@/services/forms'

export default {
  components: { ActionTools, LanguageTab },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      onFieldsChange: (props, fields) => {
        const key = Object.keys(fields)[0]
        if (this.checkboxes.includes(key)) {
          this.changeCheckbox(fields, key)
        }
      },
    })
  },
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/menu/footer/category',
          title: 'Seznam',
        },
      ],
      checkboxes: ['mfe_is_ecommerce_categories', 'mfe_is_blog'],
      items: [],
    }
  },
  methods: {
    changeCheckbox(fieldData, fieldName) {
      if (this.form.getFieldValue(fieldName)) {
        this.form.setFieldsValue({
          [this.checkboxes.find(x => x !== fieldName)]: false,
        })
      }
    },
    getData() {
      return {
        mfe_is_blog: this.form.getFieldValue('mfe_is_blog'),
        mfe_is_ecommerce_categories: this.form.getFieldValue('mfe_is_ecommerce_categories'),
        languages: this.items.filter(x => x.mfe_title.trim().length > 0),
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('menuFooterTitle/post', this.getData())
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(e) {
      let found = false
      this.items.some((value, key) => {
        if (value.lge_id === this.$store.getters['language/active']) {
          this.items[key] = { lge_id: this.$store.getters['language/active'], mfe_title: e !== undefined ? e.target.value : '' }
          found = true
          return true
        }
      })
      if (!found) {
        this.items.push(
          { lge_id: this.$store.getters['language/active'], mfe_title: e !== undefined ? e.target.value : '' },
        )
      }
    },
    nameError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('mfe_title') && getFieldError('mfe_title')
    },
  },
  created() {
    this.$store.watch(
      (state, getters) => getters['language/active'], () => {
        if (this.$store.getters['language/active'] !== null) {
          const foundObj = this.items.find(x => x.lge_id === this.$store.getters['language/active'])
          this.form.setFieldsValue({
            mfe_title: foundObj === undefined ? '' : foundObj.mfe_title,
          })
          this.form.validateFields()
        }
      },
    )
  },
}
</script>
